<template>
  <div class="login-box">
    <div v-show="showType==1" class="choice-roles">
      <div class="title-box">
        <h2 class="title">选择您的角色登录</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="roles-box">
        <div class="card" @click="handleLoginCheckClick(2)">
          <div class="img-wrap">
            <img src="../assets/img/img-laoshi.png" alt="">
            <img src="../assets/img/new.png" alt="" class="img-new">
          </div>
          <p class="text">教职工登录</p>
        </div>
        <div class="card" @click="handleLoginCheckClick(3)">
          <div class="img-wrap">
            <img src="../assets/img/img-xuesheng.png" alt="">
          </div>
          <p class="text">学生登录</p>
        </div>
        <div class="card" @click="handleLoginCheckClick(4)">
          <div class="img-wrap">
            <img src="../assets/img/img-jiazhang.png" alt="">
          </div>
          <p class="text">家长登录</p>
        </div>
        <div class="card" @click="handleLoginCheckClick(5)">
          <div class="img-wrap">
            <img src="../assets/img/img-xiaozhang.png" alt="">
          </div>
          <p class="text">校长登录</p>
          <p class="msg">全面升级为教职工登录，后续不在更新</p>
        </div>
      </div>
    </div>
    <div v-show="showType==2 && currQrStatus == 0" class="teacher">
      <div class="title-box flx-one">
        <h2 class="title mr" :class="isTeacherActive == 'ap' ? 'bd' : ''" @click="onTeacherChange('ap')">密码登录</h2>
        <h2 class="title" :class="isTeacherActive == 'sms' ? 'bd' : ''" @click="onTeacherChange('sms')">短信登录</h2>
      </div>
      <div class="content">
        <div class="left">
          <img src="../assets/img/img-laoshi.png" alt="">
          <p class="text">教职工登录</p>
        </div>
          <div class="middle" v-if="isTeacherActive == 'ap'">
            <div class="user-id input-wrap">
              <input type="text" class="input-uesr" placeholder="请输入账号" v-model="teacherApData.username"
                    @keyup="teacherLoginBtn('ap')">
              <span class="error" v-show="teacherApErrMsg.password">{{teacherApErrMsg.password}}</span>
            </div>
            <div class="password input-wrap">
              <input type="password" class="input-password" placeholder="请输入密码" v-model="teacherApData.password"
                    @keyup="teacherLoginBtn('ap')">
              <!-- <span class="error" v-show="teacherApErrMsg.password">{{teacherApErrMsg.password}}</span> -->
              <span class="forget-password" @click="$router.push('/forgetpassword?from=teacher')">忘记密码</span>
            </div>
            <div class="verification-code input-wrap">
              <input type="text" class="input-code" placeholder="请输入验证码" v-model="teacherApData.captcha"
                    @keyup="teacherLoginBtn('ap')">
              <span class="error" v-show="teacherApErrMsg.captcha">{{teacherApErrMsg.captcha}}</span>
              <span class="code-img">
                  <img :src="codeUrl" class="isWidth" alt="">
              <span class="msg" @click="getValidCode">换一个</span>
              </span>
            </div>
            <div class="but-box">
              <button class="btn-back" @click="showType=1">返回</button>
              <button class="btn-login" :class="{'bg-highlight' : isTeacherDisabled==false}" :disabled="isTeacherDisabled"
                      @click="teacherLogin('ap')">{{teacherLoginBtnText}}
              </button>
            </div>
            <p class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>和<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a></p>
          </div>
          <div class="middle" v-else>
            <div class="user-id input-wrap">
              <input type="text" class="input-uesr" v-model="tearcherSmsData.username" placeholder="请输入账号" @keyup="teacherLoginBtn('sms')">
              <span class="error" v-show="teacherSmsErrMsg.username">{{teacherSmsErrMsg.username}}</span>
            </div>
            <div class="auth-code input-wrap">
              <input class="input-password" v-model="tearcherSmsData.captcha" placeholder="短信动态验证码" @keyup="teacherLoginBtn('sms')">
              <span class="error" v-show="teacherSmsErrMsg.captcha">{{teacherSmsErrMsg.captcha}}</span>
              <span class="authcode" @click="getCode" v-show="show">获取验证码</span>
              <span class="authcode not" v-show="!show">
                {{ count }}S后重试
              </span>
            </div>
            <div class="but-box">
              <button class="btn-back" @click="showType=1">返回</button>
              <button class="btn-login" :class="{'bg-highlight' : isTeacherDisabled==false}" :disabled="isTeacherDisabled"
                      @click="teacherLogin('sms')">{{teacherLoginBtnText}}
              </button>
            </div>
            <p class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>和<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a></p>
          </div>
          <div class="right">
            <div class="qrcode-wrap qrcode-pr">
              <!-- <img class="qrcode-img" src="../assets/img/img-login-qrcode.png" alt=""> -->
              <div v-if="qrId" id="qrcode" class="qrcode-po" ref="qrcode"></div>
            </div>
            <div class="text">
              <p>打开知心慧学教师端</p>
              <p>点击 个人中心-扫一扫</p>
              <p>快速登录</p>
            </div>
          </div>
      </div>
    </div>
    <div v-show="showType==2 && (currQrStatus == 1 || currQrStatus == 2)" class="teacher">
      <div class="title-box">
        <h2 class="title">登录</h2>
      </div>
      <div class="content">
        <div class="left new-left">
          <img src="../assets/img/img-laoshi.png" alt="">
          <p class="text">老师登录</p>
        </div>
        <div class="right flx-two is-w">
          <img class="suess" src="../assets/images/CheckCircleFill.png" alt="">
          <p class="scan">扫描成功</p>
          <p class="txt">请在手机上「确认登录」</p>
          <a href="javascript:0;" class="goback mt" @click="onReset">返回短信、密码登录</a>
          <p class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>、<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a>和<a :href="`${agreementSite}/copyRight/service.html`" target="_blank">服务协议</a></p>
        </div>
      </div>
    </div>
    <!-- 111111 -->
    <div v-show="showType==3" class="student">
      <div class="title-box">
        <h2 class="title">登录</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="left">
          <img src="../assets/img/img-xuesheng.png" alt="">
          <p class="text">学生登录</p>
        </div>
        <div class="middle">
          <div class="user-id input-wrap">
            <input type="text" class="input-uesr" placeholder="请输入账号" v-model="studentData.account"
                   @keyup="studentLoginBtn">
            <span class="error">{{studentErrMsg.account}}</span>
          </div>
          <div class="password input-wrap">
            <input type="password" class="input-password" placeholder="请输入密码" v-model="studentData.password"
                   @keyup="studentLoginBtn">
            <span class="error">{{studentErrMsg.password}}</span>
            <a :href="studentEditPasswordUrl" class="forget-password">忘记密码</a>
          </div>
          <div class="verification-code input-wrap">
            <input type="text" class="input-code" placeholder="请输入验证码" v-model="studentData.code"
                   @keyup="studentLoginBtn">
            <span class="error">{{studentErrMsg.code}}</span>
            <span class="code-img">
                <img :src="codeUrl2" alt="验证码">
              </span>
            <span class="msg" @click="getValid2Code">换一个</span>
          </div>
          <div class="but-box">
            <button class="btn-back" @click="showType=1">返回</button>
            <button class="btn-login" :class="{'bg-highlight' : isStudentDisabled==false}" :disabled="isStudentDisabled"
                    @click="studentLogin">{{studentLoginBtnText}}
            </button>
          </div>
          <p class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>、<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a>和<a :href="`${agreementSite}/copyRight/service.html`" target="_blank">服务协议</a></p>
        </div>
        <div class="right">
          <div class="qrcode-wrap">
            <img class="qrcode-img" src="../assets/img/img-login-qrcode.png" alt="">
          </div>
          <div class="text">
            <p>微信公众号登录</p>
            <p>扫描二维码</p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showType==4" class="parent">
      <div class="title-box">
        <h2 class="title">登录</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="left">
          <img src="../assets/img/img-jiazhang.png" alt="">
          <p class="text">家长登录</p>
          <button class="btn-back" @click="showType=1">返回</button>
          <p style="text-align: center" class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>和<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a></p>
        </div>
        <!--<div class="middle">-->
        <!--<div class="user-id input-wrap">-->
        <!--<input type="text" class="input-uesr" placeholder="请输入账号" v-model="loginData.id">-->
        <!--</div>-->
        <!--<div class="password input-wrap">-->
        <!--<input type="password" class="input-password" placeholder="请输入密码" v-model="loginData.password">-->
        <!--</div>-->
        <!--<div class="verification-code input-wrap">-->
        <!--<input type="text" class="input-code" placeholder="请输入验证码" v-model="loginData.code">-->
        <!--<span class="code-img">-->
        <!--<img src="http://zsyportal.zhixinhuixue.com/portal/verify/code?abcd=7bfad421-4507-48df-b138-b0130f535c63&_t=1544169322968" alt="">-->
        <!--</span>-->
        <!--<span class="msg">换一个</span>-->
        <!--</div>-->
        <!--<div class="but-box">-->
        <!--<button class="btn-back" @click="showType=1">返回</button>-->
        <!--<button class="btn-login">登录</button>-->
        <!--</div>-->
        <!--</div>-->
        <div class="right">
          <div class="qrcode-wrap">
            <img class="qrcode-img" src="../assets/images/parent-qr.jpg" alt="">
          </div>
          <div class="text">
            <p>微信公众号登录</p>
            <p>扫描二维码</p>
          </div>
        </div>

      </div>
    </div>
    <div v-show="showType==5" class="principal">
      <div class="title-box">
        <h2 class="title">登录</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="left">
          <img src="../assets/img/img-xiaozhang.png" alt="">
          <p class="text">校长登录</p>
        </div>
        <div class="middle">
          <div class="user-id input-wrap">
            <input type="text" class="input-uesr" placeholder="请输入账号" v-model="schoolMasterData.account"
                   @keyup="schoolMasterLoginBtn">
            <span class="error">{{schoolMasterErrMsg.account}}</span>
          </div>
          <div class="password input-wrap">
            <input type="password" class="input-password" placeholder="请输入密码" v-model="schoolMasterData.password"
                   @keyup="schoolMasterLoginBtn">
            <span class="error">{{schoolMasterErrMsg.password}}</span>
            <span class="forget-password" >忘记密码</span>
          </div>
          <div class="verification-code input-wrap">
            <input type="text" class="input-code" placeholder="请输入验证码" v-model="schoolMasterData.code"
                   @keyup="schoolMasterLoginBtn">
            <span class="error">{{schoolMasterErrMsg.code}}</span>
            <span class="code-img">
                <img :src="codeUrl2" alt="验证码">
              </span>
            <span class="msg" @click="getValid2Code">换一个</span>
          </div>
          <div class="but-box">
            <button class="btn-back" @click="showType=1">返回</button>
            <button class="btn-login" :class="{'bg-highlight' : isSchoolMasterDisabled==false}"
                    :disabled="isSchoolMasterDisabled" @click="schoolMasterLogin">{{schoolMasterLoginBtnText}}
            </button>
          </div>

          <p class="agreement">登录即表示你同意<a :href="`${agreementSite}/copyRight/version.html`" target="_blank">版权声明</a>和<a :href="`${agreementSite}/copyRight/agreement.html`" target="_blank">软件使用协议</a></p>


        </div>
        <!--<div class="right">-->
        <!--<div class="qrcode-wrap">-->
        <!--<img class="qrcode-img" src="../assets/img/img-login-qrcode.png" alt="">-->
        <!--</div>-->
        <!--<div class="text">-->
        <!--<p>微信公众号登录</p>-->
        <!--<p>扫描二维码</p>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>
     <div v-show="showTit" class="password-tit">
       <div class="passwordTop">
         <div class="password-top fl">
           提示
         </div>
         <div @click="showTit = false" class="password-bot fr">
           <i class="el-icon-close"></i>
         </div>
       </div>
       <div class="passwordBoT">
         您已经多次输入错误密码，为安全考虑账户将锁定10分钟，请稍后再试
       </div>
       <div class="passwordBtn">
         <el-button @click="showTit = false" size="medium" type="primary">确定</el-button>
       </div>
   </div>
    <el-dialog :visible.sync="serviceDialogVisible" class="service-dialog" :close-on-click-modal="false" width="600px">
      <div slot="title" class="service-dialog-title">江西风向标智能科技有限公司<br>产品服务协议</div>
      <div class="service-dialog-content">
        <div>尊敬的用户：</div>
        <div class="ident">
          您好！欢迎您使用江西风向标智能科技有限公司（以下简称“风向标”或“服务商”）出品的“知心慧学智能精准教学系统”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议，
          您在阅读并确认使用上述产品后即表示您同意本协议的内容。
        </div>
        <div class="ident" style="margin-top: 15px">
          江西风向标智能科技有限公司（以下简称“风向标”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用风向标“知心慧学智能精准教学系统”产品及配套服务的终端客户，以下也称为“用户”）提供“知心慧学智能精准教学系统”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。
        </div>
        <div class="ident">
          风向标有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。
        </div>
        <div class="bold">一、关于购买产品</div>
        <div class="ident">1、用户系自愿购买本产品，并通过线上或线下的方式向风向标支付用以购买产品的费用，用户用以登录产品使用端口的账号来自风向标的授予。</div>
        <div class="ident">2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。</div>
        <div class="ident">3、经风向标许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权风向标采集用户的个人信息。</div>
        <div class="ident">4、产品的试用期限届满后，用户无意付费购买的，用户同意风向标随时收回风向标授予本人的登录账号。</div>
        <div class="bold">二、用户权利和义务</div>
        <div class="ident">
          1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则风向标有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知风向标，否则未经授权的使用行为均视为用户本人行为。
        </div>
        <div class="ident">
          2、风向标有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。
        </div>
        <div class="ident">
          3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。
        </div>
        <div class="ident">
          4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。
        </div>
        <div class="ident">
          5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。
        </div>
        <div class="ident">6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。</div>
        <div class="bold">三、平台管理</div>
        <div class="ident">1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。</div>
        <div class="ident">2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。</div>
        <div class="ident">3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。</div>
        <div class="ident">4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。 </div>
        <div class="ident">5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。</div>
        <div class="bold">四、知识产权</div>
        <div class="ident">1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。</div>
        <div class="ident">2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。</div>
        <div class="ident">3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。</div>
        <div class="ident">4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。</div>
        <div class="bold">五、关于个人隐私和信息采集</div>
        <div>（一）信息采集授权</div>
        <div class="ident">1、采集途径。您不可撤销地授权风向标以为您提供产品之目的，通过以下途径获取本人信息：</div>
        <div class="ident bold">（1）您确认，您在申请试用和正式使用本产品（包括APP移动端、网站、H5页面链接、微信公众号、小程序等）时，向风向标提供的信息；</div>
        <div class="ident bold">（2）您在试用和正式使用产品后，风向标向您所在学校班级任课老师和您提供的考试成绩、学习状况、在校情况等信息。</div>
        <div class="ident">2、采集范围。您不可撤销地授权风向标以为您提供产品及服务之目的，获取您个人以下范围的信息：</div>
        <div class="ident">（1）您申请试用产品时提交的姓名、所在学校、年级、班级、学号、考号等必要信息；</div>
        <div class="ident">（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；</div>
        <div class="ident">（3）您所在学校班级老师通过本产品教师端获取的您考试成绩、测评报告等。</div>
        <div>（二）信息使用授权</div>
        <div class="ident bold">您同意并不可撤销地授权风向标以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权风向标通过本产品教师端向您所在学校和班级老师推送上述信息。</div>
        <div class="ident">上述授权系您对风向标做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。</div>
        <div class="ident">以上授权期限为您作出本授权承诺之日起至您在风向标处所有业务终结之日止。</div>
        <div>（三）信息使用共享</div>
        <div class="ident">您授权风向标，除法律另有规定之外，将您提供给风向标的信息、使用产品产生的信息以及风向标根据本协议约定查询、收集的信息，用于风向标及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。</div>
        <div class="ident">您授权风向标，除法律另有规定外，基于为您提供更优质服务和产品的目的，向风向标因服务必要开展合伙的伙伴提供、查询、收集您的信息。</div>
        <div class="ident">为确保您的个人信息安全，风向标对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。</div>
        <div class="ident">本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。</div>
        <div>（四）用户知悉</div>
        <div class="ident bold">包含您姓名、所在学校、年级、班级、学号、考号等信息为您的个人信息。您应充分了解并明确知悉风向标向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的学习可能产生不利影响；这些信息被风向标依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权风向标依照本协议约定向其他机构提供您的个人信息。</div>
        <div class="bold">六、责任有限和免责条款</div>
        <div class="bold ident">1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。</div>
        <div class="bold ident">2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用作业帮的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。</div>
        <div class="bold ident">3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：</div>
        <div class="bold ident">（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；</div>
        <div class="bold ident">（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；</div>
        <div class="bold ident">（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；</div>
        <div class="bold ident">（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；</div>
        <div class="bold ident">（5）其他不能归责于公司的原因。</div>
        <div>七、其他</div>
        <div class="ident">1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。</div>
        <div class="ident">2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。</div>
        <div class="ident">3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交风向标所在地有管辖权的法院诉讼解决。</div>
        <div class="ident">4、用户对作业帮平台的意见及建议可通过客服邮箱<span class="blue">info@fxbjy.com</span>与公司进行联系。</div>
      </div>
      <div slot="footer" class="service-dialog-foot">
        <el-button @click="onDisagreeBtnClick">不同意</el-button>
        <el-button type="primary" @click="onAgreeBtnClick"><span style="padding: 0 30px">同 意</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {MessageBox} from 'element-ui'
  import Http from '../lib/Http'
  import Helper from '../lib/Helper'
  import QRCode from 'qrcodejs2'
  import Cookies from 'js-cookie';
  export default {
    name: "Login",
    data() {
      return {
        timer:null,
        currQrStatus: 0,
        showTit:false,
        forgetPassword:false,
        show: true,
        count: 60,
        showType: 1,
        qrId: "",
        loginData: {
          id: '',
          password: '',
          code: ''
        },
        //教师登录
        teacherLoginBtnText: '登录',
        isTeacherDisabled: true,
        isTeacherActive: "ap",
        teacherApData: {
          username: '',
          password: '',
          captcha: '',
          captchaKey: Helper.abcd(),
          clientType:1
        },
        tearcherSmsData: {
          username: "",
          captcha: '',
          validType: 0,
          clientType:1
          // codeKey: Helper.abcd(),
        },
        teacherApErrMsg: {
          username: '',
          password: '',
          captcha: '',
        },
        teacherSmsErrMsg: {
          username: '',
          captcha: '',
        },
        qrTimer: null,

        //学生登录
        studentLoginBtnText: '登录',
        isStudentDisabled: true,
        studentData: {
          account: '',
          password: '',
          code: '',
          codeKey: Helper.abcd(),
        },
        studentErrMsg: {
          account: '',
          password: '',
          code: '',
        },

        //校长登录
        schoolMasterLoginBtnText: '登录',
        isSchoolMasterDisabled: true,
        schoolMasterData: {
          account: '',
          password: '',
          code: '',
          codeKey: Helper.abcd(),
          client:1
        },
        schoolMasterErrMsg: {
          account: '',
          password: '',
          code: '',
        },
        codeUrl: '',
        codeUrl2: '',
        serviceDialogVisible: false,
        agreementSite: '',
        baseUrl: process.env.NODE_ENV === "production"
          ? "https://www.zhixinhuixue.com/"
          : "http://zsy.dev.xueping.com/",
        agreementAgreed: false,
        studentToken: '',
        studentEditPasswordUrl:Http.JUMP_STUDENT_URL().hm+'/editpassword'
      }
    },
    watch: {
      showType(val) {
        if(val == 2) {
          this.initTeacherQRcode();
        }else {
          if(this.qrTimer) {
            clearInterval(this.qrTimer);
          }
          this.qrTimer = null;
          this.qrId = "";
        }
      },
    },
    created() {
      this.getValidCode();
      this.getValid2Code();
      this.agreementAgreed = !!localStorage.agreementAgreed
    },
    activated() {
      this.clearQRTime();
    },
    deactivated() {
      this.clearQRTime();
    },
    methods: {
      onReset() {
        this.showType = 1;
        this.currQrStatus = 0;
      },
      clearQRTime() {
        if(this.qrTimer) {
          clearInterval(this.qrTimer);
          this.showType = 1;
        }
        this.qrTimer = null;
        this.qrId = "";
      },
      onTeacherChange(val) {
        this.isTeacherActive = val;
        this.teacherApData.username = "";
        this.teacherApData.password = "";
        this.teacherApData.captcha = "";

        this.teacherApErrMsg.username = "";
        this.teacherApErrMsg.password = "";
        this.teacherApErrMsg.captcha = "";

        this.tearcherSmsData.username = "";
        this.tearcherSmsData.captcha = "";

        this.teacherSmsErrMsg.username = "";
        this.teacherSmsErrMsg.captcha = "";
        this.getValidCode();
      },
      onStudentChange(val) {
        this.isStudentActive = val;
      },
      qrcodeScan() {//生成二维码
        this.$nextTick(() => {
          let prcode = this.$refs.qrcode;
          this.$nextTick(() => {
            prcode.setAttribute("title","");
          })
          prcode.innerHTML = "";
          // if(!prcode) return;
          // let imgs = prcode.querySelectorAll("img")
          // if(imgs.length >= 1) return;
          new QRCode(this.$refs.qrcode, {
            width: 82,  // 二维码宽度
            height: 82, // 二维码高度
            text: `${this.baseUrl}surelogin?qrId=${this.qrId}`, //登录的地址,
            // text: `http://192.168.1.92:8080/surelogin?qrId=${this.qrId}`,
            correctLevel: QRCode.CorrectLevel.H
          })
        })
      },
      getCode() {
        const TIME_COUNT = 60;
        let _this = this;
        if(!this.tearcherSmsData.username) {
          this.teacherSmsErrMsg.username = "请输入手机号！";
          return;
        }
        Http.zsyGetHttp(`/auth/captcha/teacher-sms/${this.tearcherSmsData.username}`,{},(ok => {
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          console.log(ok);
        }),(fail => {
          console.log(fail);
          if(fail.errMsg === '教师账号不存在，请检查或者联系学管！') {
            _this.teacherSmsErrMsg.username = '教师账号不存在';
          }
        }))
      },
      initTeacherQRcode() {
        Http.zsyPostHttp('/auth/teacher/qrcode/login',{},(ok) => {
          this.qrId =  ok.data.qrId;
          this.qrcodeScan();
          this.pollingApi();
        },(fail) => {
          console.log(fail);
        })
      },
      pollingApi() {
        this.qrTimer = window.setInterval(() => {
          setTimeout(() => {
            Http.zsyPostHttp(`/auth/teacher/qrcode/login/${this.qrId}/scan_info`,{},(ok) => {
                if(+ok.data.status === 3) {
                  clearInterval(this.qrTimer);
                  this.qrId = ok.data.qrcodeInfo.qrId;
                  this.qrcodeScan();
                  this.pollingApi();
                }else if(+ok.data.status === 2){
                  window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${ok.data.portalToken}`;
                } else{
                  this.currQrStatus = ok.data.status;
                }
            },0)
          })
        },2000)
      },
      onDisagreeBtnClick() {
        MessageBox.confirm('若您不同意服务协议书政策，很遗憾我们将无法为您提供服务', '同意服务协议书才能继续使用', {
          cancelButtonText: '仍不同意',
          confirmButtonText: '再次查看'
        }).then(() => {

        }).catch(() => {
          this.serviceDialogVisible = false
          this.studentLoginBtnText = '登录';
        })
      },
      onAgreeBtnClick() {
        this.studentLoginBtnText = '登录成功,正在跳转';
        this.serviceDialogVisible = false
        localStorage.agreementAgreed = 'agree'
        window.location.href = `${Http.JUMP_STUDENT_URL().hm}/index?token=${this.studentToken}`
      },
      // 登录切换
      handleLoginCheckClick(type) {
        this.showType = type;

        this.getValidCode();
        switch (type) {
          case 2:
            //埋点监控
            _hmt.push(['_trackEvent', '知心慧学', 'click', '进入教师登录']);
            break
          case 3:
            //埋点监控
            _hmt.push(['_trackEvent', '知心慧学', 'click', '进入学生登录']);
            break
          case 4:
            //埋点监控
            _hmt.push(['_trackEvent', '知心慧学', 'click', '进入家长登录']);
            break
          case 5:
            //埋点监控
            _hmt.push(['_trackEvent', '知心慧学', 'click', '进入校长登录']);
            break
          default:
            console.log("err")
            break
        }
      },
      //获取验证码
      getValidCode() {
        this.codeUrl = `${Http.API_ROOT()}auth/captcha/image/${Helper.abcd()}?_t=${new Date().getTime()}`
      },
      getValid2Code() {
        this.codeUrl2 = Http.API_ROOT() + "business/captcha/image?abcd=" + Helper.abcd() + "&_t=" + new Date().getTime();
      },
      //教师登录输入验证
      teacherLoginBtn(val) {
        if(val === 'ap') {
          this.teacherApErrMsg.username = '';
          this.teacherApErrMsg.password = '';
          this.teacherApErrMsg.captcha = '';
          //去空格
          this.teacherApData.username = Helper.trim(this.teacherApData.username);
          this.teacherApData.password = Helper.trim(this.teacherApData.password);
          this.teacherApData.captcha = Helper.trim(this.teacherApData.captcha);

          if (this.teacherApData.username != '' && this.teacherApData.password != '' && this.teacherApData.captcha != '') {
            this.isTeacherDisabled = false
          } else {
            this.isTeacherDisabled = true
          }
        }else {
          this.teacherSmsErrMsg.username = '';
          this.teacherSmsErrMsg.captcha = '';

          this.tearcherSmsData.username = Helper.trim(this.tearcherSmsData.username);
          this.tearcherSmsData.captcha = Helper.trim(this.tearcherSmsData.captcha);
          if(this.tearcherSmsData.username != "" && this.tearcherSmsData.captcha != '') {
            this.isTeacherDisabled = false
          }else {
            this.isTeacherDisabled = true
          }
        }
      },
      //教师登录
      teacherLogin(val) {
        this.teacherLoginBtnText = '登录中'
          let _this = this;
          // _hmt.push(['_trackEvent', '知心慧学', 'click', '教师登陆']);
        if(val === 'ap') {
          Http.zsyPostHttp("/auth/teacher/password/login",this.teacherApData,(ok => {
            let cookieExpires = process.env.COOKIE_EXPIRES
            Cookies.set('is_teaching', 0, {
              expires: 15,
              path: cookieExpires,
              domain: cookieExpires
            });
            if(ok.data.updatePassword) {
              _this.$router.push({
                path: '/initPassword',
                query: {
                  from : "teacher"
                }
              });
              sessionStorage.setItem("forceUpdate",ok.data.forceUpdate);
              sessionStorage.setItem("portalToken",ok.data.portalToken);
              sessionStorage.setItem("updateToken",ok.data.updateToken);
            }else {
              window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${ok.data.portalToken}`
            }

              _this.teacherLoginBtnText = '登录';
            //   _hmt.push(['_trackEvent', '知心慧学', 'callback', '教师登陆成功']);
          }),(fail) => {
            _this.teacherLoginBtnText = '登录';
            if(fail.errMsg === '账号不存在，请检查或联系学管！') {
              _this.teacherApErrMsg.username = '账号不存在!'
            }else if(fail.errMsg === "验证码不正确" || fail.errMsg === "验证码已过期") {
              _this.teacherApErrMsg.captcha = fail.errMsg;
            }else if(fail.errMsg === "用户名或密码错误！") {
              _this.teacherApErrMsg.password = fail.errMsg;
            }else if(fail.errCode === "10011") {
               _this.$alert(fail.errMsg, '提示', {
                confirmButtonText: '确定'
              });
            }else {
              _this.teacherApErrMsg.password = fail.errMsg;
            }
            _this.getValidCode();
          })
        }else {
          Http.zsyPostHttp("/auth/teacher/sms/login",this.tearcherSmsData,(ok) => {
            if(ok.data.updatePassword) {
              _this.$router.push({
                path: '/initPassword',
                query: {
                  from : "teacher"
                }
              });
              sessionStorage.setItem("forceUpdate",ok.data.forceUpdate);
              sessionStorage.setItem("portalToken",ok.data.portalToken);
              sessionStorage.setItem("updateToken",ok.data.updateToken);
              _this.teacherLoginBtnText = '登录';
            }else {
              window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${ok.data.portalToken}`
            }
          },(fail) => {
            if(fail.errMsg == "验证码已过期，请重新获取") {
              _this.teacherSmsErrMsg.captcha = "验证码已过期";
            }else if(fail.errMsg == "登录手机号格式错误") {
              _this.teacherSmsErrMsg.username = "手机号格式错误";
            }else if(fail.errMsg == "验证码不正确") {
              _this.teacherSmsErrMsg.captcha = "验证码不正确";
            }else if(fail.errCode === "10011") {
               _this.$alert(fail.errMsg, '提示', {
                confirmButtonText: '确定'
              });
            }
            _this.teacherLoginBtnText = '登录';
            _this.getValidCode();
          })
        }
      },


      //学生登录输入验证
      studentLoginBtn() {
        this.studentErrMsg.account = '';
        this.studentErrMsg.code = '';

        //去空格
        this.studentData.account = Helper.trim(this.studentData.account);
        this.studentData.password = Helper.trim(this.studentData.password);
        this.studentData.code = Helper.trim(this.studentData.code);

        if (this.studentData.account != '' && this.studentData.password != '' && this.studentData.code != '') {
          this.isStudentDisabled = false
        } else {
          this.isStudentDisabled = true
        }
      },
      //学生登录
      studentLogin() {
        let _this = this;
        _this.studentLoginBtnText = '登录中';
        //请求登陆
        //埋点监控
        _hmt.push(['_trackEvent', '知心慧学', 'click', '学生登陆']);
        Http.zsyPostHttp('/business/student/login-from-index', this.studentData, (ok) => {
          //登陆成功
          // 埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'callback', '学生登陆成功']);
          if(this.agreementAgreed){
            _this.studentLoginBtnText = '登录成功,正在跳转';
            window.location.href = `${Http.JUMP_STUDENT_URL().hm}/index?token=${ok.data}`
          } else {
            this.serviceDialogVisible = true
            this.studentToken = ok.data
          }

         // window.location.href = `${Http.JUMP_STUDENT_URL().hm}/index?token=${ok.data}`
        }, (fail) => {
          this.isStudentDisabled = true;
          //登陆失败
          _this.studentLoginBtnText = '登录';
          if (fail.errMsg == '验证码不正确') {
            _this.studentErrMsg.code = '验证码错误'
          } else {
            _this.studentErrMsg.account = '用户名或密码错误'
          }
          _this.getValid2Code();
        });
      },


      //校长登录输入验证
      schoolMasterLoginBtn() {
        this.schoolMasterErrMsg.account = '';
        this.schoolMasterErrMsg.code = '';
        //去空格
        this.schoolMasterData.account = Helper.trim(this.schoolMasterData.account);
        this.schoolMasterData.password = Helper.trim(this.schoolMasterData.password);
        this.schoolMasterData.code = Helper.trim(this.schoolMasterData.code);

        if (this.schoolMasterData.account != '' && this.schoolMasterData.password != '' && this.schoolMasterData.code != '') {
          this.isSchoolMasterDisabled = false
        } else {
          this.isSchoolMasterDisabled = true
        }
      },
      //校长登陆
      schoolMasterLogin() {
        var _this = this;
        // 埋点监控
        _hmt.push(['_trackEvent', '知心慧学', 'click', '校长登陆']);

        _this.schoolMasterLoginBtnText = '登录中';
        //请求登陆
        // Http.Axios.post(`${Http.TEACHER_API_ROOT()}basic/hm/pc/login`, this.schoolMasterData).then(function (response) {
        Http.Axios.post(`${Http.API_ROOT()}business/schoolmaster/login`, this.schoolMasterData).then(function (response) {
          // debugger
          let res = response.data;
          if (res.errCode != "00") {
            if (res.errCode == "01") {
              _this.isSchoolMasterDisabled = true;
              _this.schoolMasterLoginBtnText = '登录';
              if (res.errMsg == '验证码不正确') {
                _this.schoolMasterErrMsg.code = '验证码错误'
              } else {
                _this.schoolMasterErrMsg.account = '用户名或密码错误'
              }
              _this.getValid2Code();
            } else if (res.errCode == "02") {
              //重新登录
              Message.warning(res.errMsg);
              setTimeout(function () {
                window.vue.$router.push("/");
                window.localStorage.clear();
              }, 1000);
            } else {
              if (typeof fail == "function") {
                fail(res);
              } else {
                if (res.errMsg != "") {
                  Message.error(res.errMsg);
                }
              }
            }
          } else {
            // 埋点监控
            _hmt.push(['_trackEvent', '知心慧学', 'callback', '校长登陆成功']);
            _this.schoolMasterLoginBtnText = '登录成功,正在跳转';
            // 跳转
            window.location.href = `${Http.JUMP_URL().hm}/#/token/${encodeURIComponent(res.data)}`
          }
        }).catch(function (err) {
          _this.schoolMasterLoginBtnText = '登录';
          // _this.getValidCode2();
          // console.log(1)

        });

      }
    },
    components: {
      QRCode
    },
  }
</script>


<style lang="less">
  .el-message-box {
   .el-button {
        background-color: #3ECDBAFF !important;
        border-color: #3ECDBAFF !important;
      }
  }
</style>

<style scoped lang="less">
  @highlight-border: #3ECDBAFF;
  .flx-one {
    display: flex;
    justify-content: center;
  }
  .flx-two {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .new-left {
    width: 242px !important;
    img {
      margin-left: 80px !important;
    }
  }
  .txt {
    text-align: left;
    font-size: 16px;
    padding-left: 30px;
  }
  .goback {
    font-size: 14px;color: #666666;
  }
  .suess {
    width: 44px;
    height: 44px;
    margin: 9px 0;
  }
  .scan {
    font-size: 16px;
    color: @highlight-border;
  }
  .is-w {
    width: 373px !important;
  }
  .mr {
    margin-right: 40px;
  }
  .mt {
    margin: 40px 0;
  }

.login-box {
    position: relative;
   .password-tit {
     position: absolute;
     border: 1px solid #ccc;
      background: #fff;
      width: 318px;
      height: 162px;
      left: 36%;
      top: 31%;
      padding: 0 8px;
      .passwordTop {
            height: 30px;
            line-height: 30px;
      }
      .password-top,.password-bot {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
      }
      .password-bot {
        font-size: 25px;
        cursor: pointer;
      }
      .passwordBoT {
        margin-top: 20px;
        font-size: 16px;
      }
      .passwordBtn {
        text-align: center;
        margin-top: 20px;
      }

    }
  }
    .forget-password {
      cursor: pointer;
      color: #3ECDBA;
  }
  .dialogPassword {
    /deep/ .el-dialog {
      .el-dialog__body {
        padding-top: 10px;
      }
    }
    .dialogPassword-tit {
      font-size: 16px;
      font-weight: 700;
    }
  }
  .title-box {

    .title {
      margin-top: 40px;
      padding-bottom: 3px;
      line-height: 42px;
      font-size: 30px;
      text-align: center;
      color: #333;
      /*border-bottom: 1px dashed #888;*/
      box-sizing: border-box;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
    .border-bottom {
      display: block;
      margin: 0 auto;
      padding-top: 16px;
      width: 40px;
      border-bottom: 4px solid @highlight-border;
    }
    .bd {
      &::after {
        content: "";
        display: block;
        margin: 0 auto;
        padding-top: 16px;
        width: 40px;
        border-bottom: 4px solid @highlight-border;
      }
    }
  }

  .roles-box {
    width: 100%;
    height: 276px;
    padding-top: 40px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .card {
    width: 280px;
    height: 180px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 0px 36px 0px rgba(238, 238, 238, 1);
    }

    .img-wrap {
      position: relative;
      margin: 0 auto;
      width: 100px;
      height: 100px;
      /*border: 1px dashed #888;*/
      .img-new{
        position: absolute;
        right: -26px;
        top: -26px;
      }
    }

    .text {
      margin-top: 18px;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #333;
    }
    .msg{
      margin-top: 18px;
      color: #999999;
      text-align: center;
    }
  }

  .content {
    width: 860px;
    margin: 0 auto;
    padding-top: 7px;
    padding-bottom: 40px;
    display: flex;

    .left {
      width: 280px;
      padding-top: 30px;
      padding-bottom: 30px;
      box-sizing: border-box;
      text-align: center;
      > img {
        width: 100px;
        height: 100px;
      }

      .text {
        margin-top: 18px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 22px;
        text-align: center;
      }

    }

    .middle {
      width: 500px;

      .input-uesr, .input-password, .input-code {
        // width: 154px;

        line-height: 28px;
        font-size: 14px;
        outline: none;
        border: none;
      }

      .input-code {
        width: 90px;
      }

      .input-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 26px;
        height: 50px;
        border-bottom: 1px solid #eee;
        background-size: 16px;
      }

      .auth-code {
        background: url("../assets/img/icon-authcode.png") no-repeat 0;
      }

      .user-id {
        background: url("../assets/img/icon-user.png") no-repeat 0;
      }

      .password {
        background: url("../assets/img/icon-password.png") no-repeat 0;
      }

      .authcode,
      .not {
        display: inline-block;
        width: 88px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 4px;
      }

      .authcode {
        color: #FFFFFF;
        background: #3ECDBA;
        cursor: pointer;
      }
      .not {
        color: #666666;
        background: #EEEEEE;
        cursor: not-allowed;
      }

      .verification-code {
        background: url("../assets/img/icon-verification-code.png") no-repeat 0;

        .error {
          // width: 60px;
        }

        .code-img {
          display: inline-block;
          // width: 50px;
          height: 40px;
          line-height: 40px;
          /*overflow: hidden;*/

          > img {
            width: 50px;
            vertical-align: middle;
          }
        }

        .isWidth {
            width: 65px !important;
        }

        .msg {
          font-size: 12px;
          color: #2F8CF7;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .error {
        display: inline-block;
        font-size: 12px;
        color: #FD1919;
        padding-right: 20px;
        background: url("../assets/img/icon-error.png") no-repeat right;
        background-size: 14px;
      }

      .but-box {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        font-size: 0;
        border-radius: 4px;
        border: 1px solid #eee;

        .btn-back, .btn-login {
          width: 50%;
          height: 38px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          color: #666;
          border: none;
          outline: none;
          cursor: pointer;
        }

        .btn-back {
          background-color: #fff;
          border-radius: 4px 0 0 4px;
        }

        .btn-login {
          background-color: #eee;
          border-radius: 0 4px 4px 0;
        }

        .bg-highlight {
          color: #fff;
          background-color: #50D2C2;
        }
      }
    }

    .right {
      width: 280px;
      text-align: center;
      .qrcode-pr {
        position: relative;
      }
      .qrcode-po {
          position: absolute;
          top:50%;
          left: 50%;
          transform: translate(-50%,-50%);
      }
      .qrcode-wrap {
        width: 98px;
        height: 98px;
        margin: 0 auto;
        margin-top: 29px;
        background: url("../assets/img/bg-qrcode.png") no-repeat;

        .qrcode-img {
          width: 82px;
          height: 82px;
          margin-top: 8px;
        }
      }

      .text {
        margin-top: 28px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
      }
    }
  }

  .parent {
    .content {
      width: 560px;

      .btn-back {
        display: block;
        margin: 0 auto;
        margin-top: 14px;
        width: 120px;
        height: 30px;
        outline: none;
        cursor: pointer;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        font-size: 16px;
        color: #666666;
        background-color: #fff;
        text-align: center;
      }
    }
  }

  .principal {
    .content {
      width: 580px;
    }
  }

  .agreement {
    margin-top: 10px;
    font-size: 14px;
  }

  .agreement a {
    color: #59dace;
    padding: 0 5px;
  }
</style>
<style lang="less">
  .service-dialog {
    text-align: left;
    .el-dialog{
      width: 700px;
    }
    .bold {
      font-weight: bold;
      color: #333;
    }
    .ident{
      text-indent: 2em;
    }
    .service-dialog-title {
      font-weight: bold;
      text-align: center;
      font-size: 16px;
    }

    .service-dialog-foot {
      text-align: center;
    }
    .service-dialog-content{
      max-height: 400px;
      overflow: auto;
    }
    .el-dialog__headerbtn {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .blue {
      text-decoration: underline;
      color: blue;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?a8485c92